
import { isTransientError } from "../retry/transientErrors";
import { TELEMETRY_CATEGORIES, TELEMETRY_EVENTS, trackEvent } from "../../telemetry";





























const listeners = new Set();

export function subscribeExportTelemetry(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function emitExportTelemetry(
eventName,
context,
extra = {})
{
  const payload = {
    exportId: context.exportId,
    format: context.format,
    toolId: context.toolId,
    filename: context.filename,
    ...extra
  };

  if (process.env.NODE_ENV !== "production") {
    console.info(`[export-telemetry] ${eventName}`, payload);
  }

  trackEvent(
    TELEMETRY_EVENTS.EXPORT_EVENT,
    {
      exportEvent: eventName,
      ...payload,
    },
    {
      category: TELEMETRY_CATEGORIES.EXPORT,
      dedupeKey: `${eventName}:${payload.exportId ?? payload.toolId ?? "unknown"}`,
    },
  );

  for (const listener of listeners) {
    listener(eventName, payload);
  }
}

export function emitExportRetryTelemetry(
context,
event,
exhausted)
{
  emitExportTelemetry(exhausted ? "export_retry_exhausted" : "export_retry_scheduled", context, {
    phase: event.phase,
    attempt: event.attempt,
    maxAttempts: event.maxAttempts,
    delayMs: event.delayMs,
    isTransient: isTransientError(event.error),
    errorMessage: event.error instanceof Error ? event.error.message : String(event.error)
  });
}